// Monta a query string ignorando valores vazios
export const buildQuery = (params = {}) => {
    const query = Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return query ? `?${query}` : '';
};

const byDetails = {
    'invalid document (must be a valid CPF or CNPJ)': 'CPF ou CNPJ inválido',
    'invalid email': 'E-mail inválido',
    'invalid whatsapp number': 'WhatsApp inválido',
    'this document is already registered': 'Este CPF/CNPJ já tem cadastro',
    'this email is already registered': 'Este e-mail já tem cadastro',
    'invalid email or password': 'E-mail ou senha incorretos',
    'current password is incorrect': 'A senha atual está incorreta',
    'invalid or expired token': 'Link inválido ou expirado. Peça um novo.',
    'a material with this name and classification already exists': 'Já existe um material com esse nome e classificação',
    'transaction is already disabled': 'Este lançamento já está desabilitado',
    'transaction is already active': 'Este lançamento já está ativo',
};

const formatQty = (n) => Number(n).toLocaleString('pt-BR', { maximumFractionDigits: 3 });

// Nunca mostra `message` da API: traduz por status, `details` ou `code`
const translateError = (status, body = {}) => {
    const { details, code } = body;

    if (code === 'INSUFFICIENT_STOCK') {
        return `Estoque insuficiente de ${body.material_name}: disponível ${formatQty(body.available)}, pedido ${formatQty(body.requested)}`;
    }

    if (Array.isArray(body.password_rules) && body.password_rules.length) {
        return `Senha fraca. Falta: ${body.password_rules.join(', ')}`;
    }

    if (typeof details === 'string' && byDetails[details]) {
        return byDetails[details];
    }

    switch (status) {
        case 400: return 'Confira os dados informados e tente novamente';
        case 401: return 'Sua sessão expirou. Faça login novamente';
        case 404: return 'Registro não encontrado';
        case 409: return 'Este registro já existe ou entra em conflito com outro';
        default: return 'Algo deu errado. Tente novamente, se o problema persistir contate o suporte';
    }
};

export const processRequest = async (req) => {
    try {
        const { data, status } = await req;

        if (status >= 200 && status < 300) {
            return { status: true, ...data };
        }

        throw { response: { status, data } };
    } catch (error) {
        if (error.intercepted) {
            return { error: error.details, status: false, handled: true };
        }

        const status = error.response?.status;
        const body = error.response?.data;

        if (!status) {
            return { error: 'Não foi possível conectar ao servidor. Verifique sua internet', status: false, handled: true };
        }

        return {
            error: translateError(status, body),
            status: false,
            handled: true,
            code: body?.code,
            password_rules: body?.password_rules,
            original: error,
        };
    }
};

// Padrão dos controllers: devolve o corpo da API ou { error, status: false }
export const request = async (req) => {
    try {
        const response = await processRequest(req);
        if (!response.status) throw response.error;
        return response;
    } catch (error) {
        return { error, status: false };
    }
};
